import React, { Component } from 'react';
import PrintLabels from '../generics/PrintLabels';

export default class PrintInventoryItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      box: {
        id: props.inventory.id,
        brand: props.inventory.brand ? props.inventory.brand.brand_name : '-',
        packingDate: props.inventory.packing_date,
        expiration_date: props.inventory.expiration_date,
        item: props.inventory.item ? props.inventory.item.name : '-',
        weight: props.inventory.weight,
        pieces: props.inventory.number_items ? props.inventory.number_items : '-',
        production_session: props.inventory.session_product ? props.inventory.session_product.id : '-',
        grade: (props.inventory.extra_info && props.inventory.extra_info.grade)? props.inventory.extra_info.grade.grade: 'N/A',
        allergies: props.inventory.item.allergies ? props.inventory.item.allergies : '-',
        ingredients: props.inventory.item.ingredients ? props.inventory.item.ingredients : '-'
      },
      invoice: {
        vendor: {
          name: props.inventory.vendor ? props.inventory.vendor: '-'
        }
      }
    };
  }

  printLabel = (index) => {
    var content = document.getElementById("toPrint" + index);
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    },50)
  };

  render() {
    let styleFrame = {
      height: '0px',
      width: '0px',
      position: 'absolute'
    }
    return (
      <div>
        <a className="btn btn-default mr-05 m-0" onClick={()=>this.printLabel(1)}><i className="fa fa-print"></i></a>
        <div>
          <PrintLabels invoice = {this.state.invoice} box={this.state.box} index={1}  printLabel={this.printLabel}/>
          <iframe title ="toPrint" id="ifmcontentstoprint" style = {styleFrame}></iframe>
        </div>
      </div>
    )
  }
}
